var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      class: _vm.classes,
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "label",
        {
          staticClass: "trbo-a-question-input__label",
          attrs: { for: _vm.inputId },
        },
        [_vm._v(_vm._s(_vm.questionData.inputLabel))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "trbo-a-question-input__content" }, [
        _vm.inputAttributes.type === "checkbox"
          ? _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value,
                      expression: "value",
                    },
                  ],
                  staticClass: "trbo-a-question-input__input",
                  attrs: {
                    id: _vm.inputId,
                    placeholder: _vm.inputPlaceholder,
                    "aria-invalid": _vm.ariaInvalid,
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.value)
                      ? _vm._i(_vm.value, null) > -1
                      : _vm.value,
                  },
                  on: {
                    invalid: _vm.handleInvalid,
                    change: function ($event) {
                      var $$a = _vm.value,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.value = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.value = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.value = $$c
                      }
                    },
                  },
                },
                "input",
                _vm.inputAttributes,
                false
              )
            )
          : _vm.inputAttributes.type === "radio"
          ? _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value,
                      expression: "value",
                    },
                  ],
                  staticClass: "trbo-a-question-input__input",
                  attrs: {
                    id: _vm.inputId,
                    placeholder: _vm.inputPlaceholder,
                    "aria-invalid": _vm.ariaInvalid,
                    type: "radio",
                  },
                  domProps: { checked: _vm._q(_vm.value, null) },
                  on: {
                    invalid: _vm.handleInvalid,
                    change: function ($event) {
                      _vm.value = null
                    },
                  },
                },
                "input",
                _vm.inputAttributes,
                false
              )
            )
          : _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value,
                      expression: "value",
                    },
                  ],
                  staticClass: "trbo-a-question-input__input",
                  attrs: {
                    id: _vm.inputId,
                    placeholder: _vm.inputPlaceholder,
                    "aria-invalid": _vm.ariaInvalid,
                    type: _vm.inputAttributes.type,
                  },
                  domProps: { value: _vm.value },
                  on: {
                    invalid: _vm.handleInvalid,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.value = $event.target.value
                    },
                  },
                },
                "input",
                _vm.inputAttributes,
                false
              )
            ),
        _vm._v(" "),
        _vm.icon
          ? _c(
              "div",
              { staticClass: "trbo-a-question-input__icon" },
              [
                _c("icon", {
                  staticClass: "trbo-a-question-input__icon__image",
                  attrs: { name: _vm.icon },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "trbo-a-question-input__actions" }, [
        _c(
          "button",
          {
            staticClass: "trbo-a-question-input__button",
            attrs: { type: "submit" },
          },
          [_vm._v(_vm._s(_vm.questionData.inputButtonTitle))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }